import { CAMPAIGN_PRICING, PER_MONTH } from '../constants';

export const getCampaignPricing = (campaignCode) => {
  return CAMPAIGN_PRICING[campaignCode] ?? PER_MONTH;
};
